import { createMuiTheme } from '@material-ui/core';

//For getting access token
export const getHashParams = () => {
  var hashParams: any = {};
  var e,
    r = /([^&;=]+)=?([^&;]*)/g,
    q = window.location.hash.substring(1);
  while ((e = r.exec(q))) {
    hashParams[e[1]] = decodeURIComponent(e[2]);
  }
  return hashParams;
};

//MaterialUI Theme
export const theme = createMuiTheme({
  palette: {
    primary: {
      //main: '#006494',
      //main: '#ff7f50',
      main: '#00abfa',
    },
    secondary: {
      main: '#3D3B8E',
    },
    type: 'dark',
    background: {
      default: 'black',
    },
  },
});

export const getCurrentUser = (accessToken: string) => {
  const Spotify = require('spotify-web-api-js');
  const spotifyWebApi = new Spotify();
  spotifyWebApi.setAccessToken(accessToken);

  return spotifyWebApi.getMe();
};
